<template>
  <v-container fluid fill-height class="background fill-height">
    <v-card class="white mx-auto" width="30vw" height="50vh" min-height="480px">
      
      <div class="white mb-3">
        <v-img max-width="20vw" class="mx-auto" src="../assets/DigiWheel_Logo_Evolution_Company_RGB_Yellow_Black.svg"/>
      </div>

      <p class="text-body-2 text-center grey--text mb-4">
        {{ $t('resetPassword.codeSentTo') }} {{ resetEmail }}
      </p>

      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        class="text-center"
      >
        <v-text-field
          v-model="code"
          :placeholder="$t('resetPassword.codeLabel')"
          :rules="codeRules"
          class="mb-n2 rounded-lg mx-auto"
          style="width: 70%"
          outlined
          density="compact"
          single-line
          maxlength="6"
          @input="handleCodeInput"
        ></v-text-field>

        <v-btn
          style="width: 70%"
          color="black white--text"
          class="rounded-lg mb-3"
          :disabled="!valid || loading"
          :loading="loading"
          @click="verifyCode"
        >
          {{ $t('resetPassword.verifyButton') }}
        </v-btn>

        <div>
          <v-btn
            text
            color="primary"
            @click="resendCode"
            :disabled="resending"
          >
            {{ $t('resetPassword.resendCode') }}
          </v-btn>
        </div>
      </v-form>

      <v-alert
        v-if="successMessage"
        type="success"
        class="mx-8 mt-4"
        dense
      >
        {{ successMessage }}
      </v-alert>

      <v-alert
        v-if="errorMessage"
        type="error"
        class="mx-8 mt-4"
        dense
      >
        {{ errorMessage }}
      </v-alert>

    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "VerifyCode",
  data: () => ({
    valid: false,
    code: '',
    loading: false,
    resending: false,
    successMessage: '',
    errorMessage: '',
    codeRules: [
      v => !!v || 'Code is required',
      v => /^\d{6}$/.test(v) || 'Code must be 6 digits'
    ]
  }),
  computed: {
    ...mapGetters(['getPasswordResetEmail']),
    resetEmail() {
      return this.getPasswordResetEmail || '';
    }
  },
  mounted() {
    if (!this.resetEmail) {
      this.$router.push('/resetpassword');
    }
  },
  methods: {
    ...mapActions(['verifyResetCode', 'requestPasswordReset']),
    handleCodeInput(value) {
      this.code = value.replace(/\D/g, '');
    },
    async verifyCode() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      this.errorMessage = '';
      this.successMessage = '';

      try {
        const result = await this.verifyResetCode({ 
          email: this.resetEmail, 
          code: this.code 
        });
        
        if (result.success) {
          this.successMessage = 'Code verified successfully!';
          // Navigate to change password page after short delay
          setTimeout(() => {
            this.$router.push('/changepassword');
          }, 1000);
        } else {
          this.errorMessage = result.error || this.$t('resetPassword.errors.invalidCode');
        }
      } catch (error) {
        this.errorMessage = 'An error occurred. Please try again.';
      } finally {
        this.loading = false;
      }
    },
    async resendCode() {
      this.resending = true;
      this.errorMessage = '';
      this.successMessage = '';

      try {
        const result = await this.requestPasswordReset(this.resetEmail);
        if (result.success) {
          this.successMessage = this.$t('resetPassword.codeSent');
          this.code = '';
        } else {
          this.errorMessage = 'Failed to resend code. Please try again.';
        }
      } catch (error) {
        this.errorMessage = 'An error occurred. Please try again.';
      } finally {
        this.resending = false;
      }
    }
  }
};
</script>

<style scoped>
.background {
  background-color: #f5f5f5;
}
</style>